export const APPLIED_CASH_STRING = 'Applied CurbNTurf Cash';
export const APPLIED_AFFILIATE_REWARDS = 'Applied Affiliate Rewards';

export const DEFAULT_CHECK_IN_TIME = '14:00:00';
export const DEFAULT_CHECK_OUT_TIME = '12:00:00';

/**
 * Hour (listing timezone) that closes a day for booking: a check-in on D with N days' notice
 * can be booked until this hour on D - N, and an unanswered request expires at this hour.
 */
export const BOOKING_CUTOFF_HOUR = 22;

/** A waiting reservation counts as overdue once its last status change is this many hours old. */
export const RESERVATION_OVERDUE_HOURS = 24;

/**
 * The article categories the public site knows (an article's first category
 * picks its section and call to action). Anything else shows as Travel
 * Stories. The site's own label-to-key map is in
 * client/libs/feature-cnt/content/src/lib/articles/articles.live-source.ts;
 * a spec there checks these all map.
 */
export const ARTICLE_CATEGORIES = [
  'Boondocking',
  'Camping Tips',
  'Trip Planning',
  'CurbNTurf Host',
  'Cooking and Recipes',
  'Travel Destinations',
  'Maintenance and Repairs',
  'Gear and Accessories',
  'Travel Stories',
] as const;

/** Charged on every CurbNTurf Cash withdrawal; recorded as its own ledger row. */
export const CNT_CASH_WITHDRAWAL_FEE = 5;
